module.exports = __webpack_public_path__ + "img/132.a4d15fd0.jpg";